<template>
    <v-dialog width="500" v-model="isOpenTeamView">
        <v-card>
            <v-card-title
                primary-title
                class="d-flex flex-column justify-center"
            >
                <div class="d-block">
                    <h2 class="font-weight-light primary--text text-center">
                        Equipo de
                        {{ dutty_manager ? dutty_manager.nombre_completo : '' }}
                    </h2>
                    <h4 class="font-weight-light primary--text text-center">
                        {{ currentNameMonthYear }}
                    </h4>
                </div>
            </v-card-title>

            <v-card-text class="pa-1">
                <v-row no-gutters class="mb-md-n12">
                    <v-col cols="9">
                        <v-autocomplete
                            v-if="$store.getters['login/hasManagerPermission']"
                            class="pa-4"
                            :items="comerciales"
                            v-model="form.commercial_id_arr"
                            multiple
                            item-text="nombreCompleto"
                            item-value="id"
                            prepend-inner-icon="mdi-account-tie-voice-outline"
                            label="Comercial"
                            clearable
                        >
                            <template #item="{ item }">
                                <v-row>
                                    <v-col cols="9">
                                        {{ item.nombreCompleto }}
                                    </v-col>
                                    <v-col cols="3">
                                        <v-icon
                                            :color="
                                                estadoComercial[item.estado]
                                            "
                                            class="
                                                d-flex
                                                justify-center
                                                overline
                                            "
                                        >
                                            mdi-circle
                                        </v-icon>
                                    </v-col>
                                </v-row>
                            </template>
                            <template #selection="{ item }">
                                <v-chip small color="lime">{{
                                    item.nombreCompleto
                                }}</v-chip>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col
                        cols="3"
                        class="d-flex justify-center align-self-center"
                    >
                        <v-btn
                            class="mb-md-3"
                            v-if="hasManagerPermission"
                            @click="submit()"
                            :disabled="!form.commercial_id_arr.length"
                            small
                            color="success"
                            outlined
                        >
                            Añadir
                            <v-icon> mdi-account-plus-outline </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-data-table
                    class="py-4"
                    :headers="headers"
                    :items="tableItems"
                    :footer-props="footer_props"
                    disable-pagination
                    hide-default-footer
                    disable-sort
                >
                    <template v-slot:item.created_on="{ item }">
                        {{ formatDate(item.created_on) }}
                    </template>
                    <template v-slot:item.Actions="{ item }">
                        <v-btn
                            v-if="hasManagerPermission"
                            fab
                            @click="openDeleteDialog(item)"
                            x-small
                            color="red"
                            outlined
                        >
                            <v-icon> mdi-delete </v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-card-text>

            <v-card-actions class="d-flex justify-end">
                <v-btn text color="red" @click="isOpenTeamView = false">
                    Cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { dateToISOString, clone, estadoComercial } from '@/util/libUtil.js';

export default {
    name: 'correctiveteamToView',
    data: () => ({
        estadoComercial,
        search: null,
        headers: [
            {
                text: 'Comerciales',
                align: 'start',
                value: 'account.nombre_completo',
                sortable: false,
            },
            {
                text: 'Fecha',
                align: 'start',
                value: 'created_on',
                sortable: false,
            },
            {
                text: 'Acciones',
                value: 'Actions',
                sortable: false,
                align: 'center',
            },
        ],
        footer_props: {
            disableItemsPerPage: true,
            itemsPerPageOptions: [-1],
        },
    }),
    methods: {
        submit() {
            this.form.dutty_manager = this.dutty_manager;
            this.$store.dispatch('areaPersonal/calculadora/addTeam', {});
        },
        formatDate(date) {
            return new Date(date).toISOString().substr(0, 7);
        },
        openDeleteDialog(item) {
            let deleteObj = {
                toDeleteId: [item.id],
                toDeleteType: 'TEAM',
                isOpenDeleteDialog: true,
            };

            this.$store.commit('util/deleteDialog', clone(deleteObj));
        },
    },
    props: {
        dutty_manager: null,
    },
    computed: {
        tableItems() {
            return this.duttyManagerId
                ? this.teams.filter(
                      (team) => team.dutty_manager.id == this.duttyManagerId
                  )
                : [];
        },
        cuenta() {
            return JSON.parse(localStorage.getItem('cuenta'));
        },
        isOpenTeamView: {
            get() {
                return this.$store.state.areaPersonal.calculadora.teamForm
                    .isOpenTeamView;
            },
            set(value) {
                this.$store.commit(
                    'areaPersonal/calculadora/isOpenTeamView',
                    value
                );
            },
        },
        form: {
            get() {
                return this.$store.state.areaPersonal.calculadora.teamForm.form;
            },
            set(value) {
                this.$store.commit('areaPersonal/calculadora/teamsForm', value);
            },
        },
        teamToView: {
            get() {
                return this.$store.state.areaPersonal.calculadora.teamForm
                    .teamToView;
            },
            set(value) {
                this.$store.commit(
                    'areaPersonal/calculadora/teamToView',
                    value
                );
            },
        },
        ...mapState('teletrabajo', {
            comerciales: (state) => state.Comerciales,
        }),
        ...mapState('areaPersonal/calculadora', {
            teams: (state) => state.teamForm.teams,
            currentDate: (state) => state.date,
            duttyManagerId: (state) => state.teamForm.duttyManagerId,
            selectedComercial: (state) => state.selectedComercial,
            dateActualInmutable: (state) => state.dateActualInmutable,
        }),
        ...mapGetters('areaPersonal/calculadora', {
            currentNameMonthYear: 'currentNameMonthYear',
        }),
        ...mapGetters('login', {
            hasManagerPermission: 'hasManagerPermission',
            hasComercialPermission: 'hasComercialPermission',
        }),
    },
    watch: {
        selectedComercial: {
            immediate: true,
            handler: function (newValue) {
                if (newValue != null) {
                    if (this.currentDate) {
                        let params = {
                            commercial: newValue.id,
                            created_on: `${this.currentDate.getFullYear()}-${
                                this.currentDate.getMonth() + 1
                            }`,
                        };
                        if (
                            dateToISOString(this.currentDate) >=
                            this.dateActualInmutable
                        ) {
                            params = { ...params, is_active: true };
                        }
                        this.$store.dispatch(
                            'areaPersonal/calculadora/fetchFactorCorrector',
                            params
                        );
                    }
                }
            },
        },
        currentDate: {
            immediate: true,
            handler: function (newValue) {
                if (this.hasManagerPermission && this.selectedComercial) {
                    let params = {
                        commercial: this.selectedComercial.id,
                        created_on: `${newValue.getFullYear()}-${
                            newValue.getMonth() + 1
                        }`,
                    };

                    if (dateToISOString(newValue) >= this.dateActualInmutable) {
                        params = { ...params, is_active: true };
                    }
                    this.$store.dispatch(
                        'areaPersonal/calculadora/fetchFactorCorrector',
                        params
                    );
                } else if (this.hasComercialPermission) {
                    let params = {
                        commercial: this.cuenta.id,
                        created_on: `${newValue.getFullYear()}-${
                            newValue.getMonth() + 1
                        }`,
                    };

                    if (dateToISOString(newValue) >= this.dateActualInmutable) {
                        params = { ...params, is_active: true };
                    }

                    this.$store.dispatch(
                        'areaPersonal/calculadora/fetchFactorCorrector',
                        params
                    );
                }
            },
        },
        isOpenViewFactor: {
            immediate: true,
            handler: function (newValue, oldValue) {
                if (!newValue && oldValue) {
                    this.factorView = null;
                }
            },
        },
    },
};
</script>